export default "<!-- <script src=\"https://code.highcharts.com/5/js/highcharts.js\"></script> -->\n<div #chart class=\"chart-style\"></div>\n"